import { FC, useState, useEffect } from 'react';
import { CustomEditor, ImageUpload, Input } from '../../../commons';

interface NewCountryFormProps {
  values: any;
  setFieldValue: any;
}
const CountryForm: FC<NewCountryFormProps> = ({ values, setFieldValue }) => {
  const [initialValue, setInitialValue] = useState(values.description);

  const handleImageChange = (e: any) => {
    const file = e.target.files[0];
    setFieldValue('imageFile', file);

    const image = URL.createObjectURL(file);
    setFieldValue('imageCover', image);
  };

  useEffect(() => {
    setFieldValue('description', initialValue);
  }, [initialValue]);

  return (
    <div className='space-y-6'>
      <div className='grid grid-cols-1 md:grid-cols-2 gap-6'>
        <Input type='text' name='name' label='Country Name' />
        <Input type='text' name='title' label='Country Headline' />
      </div>

      <div className='space-y-2'>
        <label className='block text-sm font-bold text-gray-700 dark:text-gray-300'>
          Country Description
        </label>
        <CustomEditor
          placeholder='Type country description here...'
          onChange={setInitialValue}
          value={initialValue}
          name='description'
        />
      </div>

      <div className='grid grid-cols-1 md:grid-cols-3 gap-6 items-start'>
        <div className='md:col-span-2'>
          <Input type='textarea' rows={5} name='countrySummary' label='Country Summary' />
        </div>
        <div className='md:col-span-1'>
          <label className='block text-sm font-bold text-gray-700 dark:text-gray-300 mb-2'>
            Featured Image
          </label>
          <ImageUpload tourImage={values.imageCover} tourImageHandler={handleImageChange} />
        </div>
      </div>
    </div>
  );
};

export default CountryForm;
